import React, { useContext, useMemo, useState } from "react";
import { TranslatorContext } from "../../context/Translator";
import { SalesChartComponent } from "../charts";
import { Dropdown } from "react-bootstrap";

export default function SalesCardComponent({ data = [], previousData = [], title }) {
    const { t, n } = useContext(TranslatorContext);
    const [dateRange, setDateRange] = useState('last_week'); // last_day, last_week, last_month, last_year

    const {
        totalAmount,
        previousAmount,
        percentChange,
        trend
    } = useMemo(() => {
        // Calculate total amount from current data
        const total = data.reduce((sum, item) => sum + (item.total || 0), 0);
        // console.log("total:", total);
        // Calculate total amount from previous period
        const prevTotal = previousData.reduce((sum, item) => sum + (item.total || 0), 0);
        // console.log("prevTotal:", prevTotal);
        
        // Calculate percent change
        let percent = 0;
        if (prevTotal > 0) {
            percent = ((total - prevTotal) / prevTotal) * 100;
        }
        
        return {
            totalAmount: total,
            previousAmount: prevTotal,
            percentChange: Math.abs(Math.round(percent * 100) / 100),
            trend: percent >= 0 ? 'trending_up' : 'trending_down'
        };
    }, [data, previousData]);

    const handleRangeChange = (range) => {
        setDateRange(range);
        // You might want to trigger a parent callback here to fetch new data
    };

    const chartData = useMemo(() => {
        // Transform data for chart component
        return data.map(item => ({
            name: item.username,
            value: item.total
        }));
    }, [data]);

    return (
        <div className={`mc-sales-card ${title === 'Tổng Nạp' ? 'green' : title === 'Tổng Rút' ? 'orange' : ''}`}>
            <div className="mc-sales-card-group">
                <div className="mc-card-header">
                    <h4 className="mc-card-title">{t(title)}</h4>
                    <Dropdown bsPrefix="mc-dropdown">
                        <Dropdown.Toggle bsPrefix="mc-dropdown-toggle">
                            <i className='material-icons'>more_horiz</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu align="end" className="mc-dropdown-paper">
                            <button 
                                type='button' 
                                className='mc-dropdown-menu'
                                onClick={() => handleRangeChange('last_day')}
                            >
                                <i className='material-icons'>history</i>
                                <span>{t('last_day')}</span>
                            </button>
                            <button 
                                type='button' 
                                className='mc-dropdown-menu'
                                onClick={() => handleRangeChange('last_week')}
                            >
                                <i className='material-icons'>history</i>
                                <span>{t('last_week')}</span>
                            </button>
                            <button 
                                type='button' 
                                className='mc-dropdown-menu'
                                onClick={() => handleRangeChange('last_month')}
                            >
                                <i className='material-icons'>history</i>
                                <span>{t('last_month')}</span>
                            </button>
                            <button 
                                type='button' 
                                className='mc-dropdown-menu'
                                onClick={() => handleRangeChange('last_year')}
                            >
                                <i className='material-icons'>history</i>
                                <span>{t('last_year')}</span>
                            </button>
                        </Dropdown.Menu>
                    </Dropdown>
                </div>
                <div className={`mc-sales-card-amount ${trend} ${trend === 'trending_up' ? 'green' : 'red'}`}>
                    <h3>{n(totalAmount)}</h3>
                    <p>
                        {percentChange}%
                        <i className='material-icons'>{trend}</i>
                    </p>
                </div>
                <p className="mc-sales-card-compare">
                    ${n(previousAmount)} in {t(dateRange)}
                </p>
            </div>
            <SalesChartComponent data={chartData} />
        </div>
    );
}
